import React from "react";
import styled from "styled-components";
import {
  BRAND_GOLD,
  BRAND_INK,
  BRAND_INK_LIFT,
} from "../config/brandColors";

/**
 * Lusuku's official-store mark. Keep this platform-owned rather than tinting it
 * with a vendor's colours so shoppers learn one consistent trust signal.
 */
const OfficialStoreBadge = ({ size = "medium", className, ...props }) => (
  <Badge
    className={className}
    $size={size}
    title="Official store verified by Lusuku"
    {...props}
  >
    <OfficialStoreSeal aria-hidden="true" />
    <span>Official store</span>
  </Badge>
);

const OfficialStoreSeal = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M23 12l-2.44-2.79.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69l-3.61.81.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.81L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72L6.29 12.9l1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.49-7.33 7.35z"
    />
  </svg>
);

const Badge = styled.span`
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: ${({ $size }) => ($size === "small" ? "4px" : "6px")};
  padding: ${({ $size }) =>
    $size === "small" ? "3px 7px 3px 5px" : "6px 12px 6px 7px"};
  border: 1px solid ${BRAND_GOLD};
  border-radius: 999px;
  background: ${BRAND_INK};
  color: ${BRAND_GOLD};
  box-shadow:
    0 4px 12px rgba(7, 42, 67, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  font-size: ${({ $size }) => ($size === "small" ? "0.62rem" : "0.78rem")};
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.015em;
  white-space: nowrap;
  text-transform: none;
  transition: transform 180ms ease, box-shadow 180ms ease,
    background-color 180ms ease;

  svg {
    display: block;
    color: ${BRAND_GOLD} !important;
    width: ${({ $size }) => ($size === "small" ? "12px" : "17px")};
    height: ${({ $size }) => ($size === "small" ? "12px" : "17px")};
    flex-shrink: 0;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25));
  }

  span {
    color: #ffffff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
  }

  &:hover {
    transform: translateY(-1px);
    background: ${BRAND_INK_LIFT};
    box-shadow:
      0 6px 16px rgba(7, 42, 67, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.24);
  }
`;

export { OfficialStoreSeal };
export default OfficialStoreBadge;
